// 库存备货清单tabs状态
export const stockListTabBars = [
  { title: '待处理任务', name: 'pendingTask' },
  { title: '我的待处理', name: 'myPending' },
  { title: '我的已处理', name: 'myProcessed' }
]
// 物流入库列表tabs状态
export const goToWarehouseListTabBars = [
  { title: '待验收任务', name: 'forAcceptance' },
  { title: '待入库任务', name: 'stockPending' },
  { title: '已处理任务', name: 'handled' }
]
// 自提发货tabs状态
export const shipmentTabBars = [
  { title: '待处理任务', name: 'pendingTask' },
  { title: '我的已处理', name: 'myProcessed' }
]
// 待审核盘点任务tabs状态
export const pendingTabBars = [
  { title: '待审核', name: 'pending' },
  { title: '我的待审核', name: 'myPending' },
  { title: '我的已审核', name: 'myAudited' }
]
// 待处理锁库异常列表tabs状态
export const lockTabBars = [
  { title: '待处理任务', name: 'pendingTask' },
  { title: '已处理任务', name: 'taskProcessed' }
]
// 待处理锁库异常列表tabs状态
export const historyTabBars = [
  { title: '单据查询', name: 'documentsQuery' },
  { title: '产品查询', name: 'productQuery' }
]
// 实时库存查询列表tabs状态
export const inTimeInventor = [
  { title: '仓库查询', name: 'WarehouseQueries' },
  { title: '产品查询', name: 'productQuery' }
]

// ---------------------------搜索条件---------------------------
// 库存备货清单-待处理任务-搜索条件
export const stockSelector1 = [
  { label: '备货编号', value: 'stockupCode' },
  { label: '所在仓库', value: 'storageName' },
  { label: '备货方式', value: 'distributionType' },
  { label: '备货仓库', value: 'ocsStorageName' },
  { label: '发起人', value: 'createUser' },
  { label: '请求备货时间', value: 'createDate' },
  { label: '认领人', value: 'staffCnName' },
  { label: '认领时间', value: 'processDate' }
]
// -我的待处理
export const stockSelector2 = [
  { label: '备货编号', value: 'stockupCode' },
  { label: '所在仓库', value: 'storageName' },
  { label: '备货方式', value: 'distributionType' },
  { label: '备货仓库', value: 'ocsStorageName' },
  { label: '发起人', value: 'createUser' },
  { label: '请求备货时间', value: 'createDate' },
  { label: '认领时间', value: 'processDate' },
  { label: '报缺状态', value: 'lackState' },
  { label: '备货状态', value: 'stockupState' },
  { label: '物流订单状态', value: 'logisticsState' }

]
// -我的已处理
export const stockSelector3 = [
  { label: '备货编号', value: 'stockupCode' },
  { label: '所在仓库', value: 'storageName' },
  { label: '备货方式', value: 'distributionType' },
  { label: '备货仓库', value: 'ocsStorageName' },
  { label: '发起人', value: 'createUser' },
  { label: '请求备货时间', value: 'createDate' },
  { label: '处理时间', value: 'updateDate' },
  { label: '报缺状态', value: 'lackState' },
  { label: '备货状态', value: 'stockupState' },
  { label: '物流订单状态', value: 'logisticsState' },
  { label: '备货时间', value: 'lockDate' }
]
// 物流入库-待验收任务-搜索条件
export const logisticsCompany1 = [
  { label: '发货入库编号', value: 'instockNumber' },
  { label: '入库仓库', value: 'deliverStorageName' },
  { label: '入库类型', value: 'instockType' },
  { label: '配送方式', value: 'logisticType' },
  { label: '物流公司', value: 'logisticCompany' },
  { label: '物流单号', value: 'logisticNumber' },
  { label: '发起人', value: 'createUser' },
  { label: '发起时间', value: 'createDate' },
  { label: '型号', value: 'proModel' },
  { label: '订货号', value: 'proOrdernum' }
]
// 待入库任务
export const logisticsCompany2 = [
  { label: '发货入库编号', value: 'instockNumber' },
  { label: '入库仓库', value: 'deliverStorageName' },
  { label: '入库类型', value: 'instockType' },
  { label: '配送方式', value: 'logisticType' },
  { label: '物流公司', value: 'logisticCompany' },
  { label: '物流单号', value: 'logisticNumber' },
  { label: '发起人', value: 'createUser' },
  { label: '发起时间', value: 'createDate' },
  { label: '型号', value: 'proModel' },
  { label: '订货号', value: 'proOrdernum' }
]
// 已处理任务
export const logisticsCompany3 = [
  { label: '发货入库编号', value: 'instockNumber' },
  { label: '入库仓库', value: 'deliverStorageName' },
  { label: '入库类型', value: 'instockType' },
  { label: '配送方式', value: 'logisticType' },
  { label: '物流公司', value: 'logisticCompany' },
  { label: '物流单号', value: 'logisticNumber' },
  { label: '发起人', value: 'createUser' },
  { label: '发起时间', value: 'createDate' },
  { label: '处理时间', value: 'disposeDate' },
  { label: '入库状态', value: 'instockState' },
  { label: '入库时间', value: 'inDate' },
  { label: '型号', value: 'proModel' },
  { label: '订货号', value: 'proOrdernum' }

]
// 配送入库列表-待验收任务-搜索条件
export const distribution1 = [
  { label: '发货入库编号', value: 'instockNumber' },
  { label: '入库仓库', value: 'deliverStorageName' },
  { label: '入库类型', value: 'instockType' },
  { label: '配送方式', value: 'logisticType' },
  { label: '发起人', value: 'createUser' },
  { label: '发起时间', value: 'createDate' },
  { label: '预计送达时间', value: 'supplierDeliverDate' },
  { label: '型号', value: 'proModel' },
  { label: '订货号', value: 'proOrdernum' }
]
// 待入库
export const distribution2 = [
  { label: '发货入库编号', value: 'instockNumber' },
  { label: '入库仓库', value: 'deliverStorageName' },
  { label: '入库类型', value: 'instockType' },
  { label: '配送方式', value: 'logisticType' },
  { label: '发起人', value: 'createUser' },
  { label: '发起时间', value: 'createDate' },
  { label: '预计送达时间', value: 'supplierDeliverDate' },
  { label: '型号', value: 'proModel' },
  { label: '订货号', value: 'proOrdernum' }
]
// 已处理
export const distribution3 = [
  { label: '发货入库编号', value: 'instockNumber' },
  { label: '入库仓库', value: 'deliverStorageName' },
  { label: '入库类型', value: 'instockType' },
  { label: '配送方式', value: 'logisticType' },
  { label: '发起人', value: 'createUser' },
  { label: '发起时间', value: 'createDate' },
  { label: '处理人', value: 'supplierDeliverDate' },
  { label: '入库状态', value: 'instockState' },
  { label: '处理时间', value: 'disposeDate' },
  { label: '型号', value: 'proModel' },
  { label: '订货号', value: 'proOrdernum' }

]
// 快递/物流发货列表-待处理任务-搜索条件
export const shipments1 = [
  { label: '发货编号', value: 'deliverNumber' },
  { label: '所在仓库', value: 'storageName' },
  { label: '发货类型', value: 'outstockType' },
  { label: '发货方式', value: 'deliverMode' },
  { label: '发起人', value: 'createUser' },
  { label: '请求发货时间', value: 'createDate' },
  { label: '认领人', value: 'staffCnName' },
  { label: '认领时间', value: 'processDate' },
  { label: '型号', value: 'proModel' },
  { label: '订货号', value: 'proOrdernum' }
]
// 我的待处理
export const shipments2 = [
  { label: '发货编号', value: 'deliverNumber' },
  { label: '所在仓库', value: 'storageName' },
  { label: '发货类型', value: 'outstockType' },
  { label: '发货方式', value: 'deliverMode' },
  { label: '发起人', value: 'createUser' },
  { label: '请求发货时间', value: 'createDate' },
  { label: '报缺状态', value: 'lackState' },
  { label: '发货状态', value: 'state' },
  { label: '物流订单状态', value: 'logisticsState' },
  { label: '型号', value: 'proModel' },
  { label: '订货号', value: 'proOrdernum' }
]
// 已处理
export const shipments3 = [
  { label: '发货编号', value: 'deliverNumber' },
  { label: '所在仓库', value: 'storageName' },
  { label: '发货类型', value: 'outstockType' },
  { label: '发货方式', value: 'deliverMode' },
  { label: '发起人', value: 'createUser' },
  { label: '请求发货时间', value: 'createDate' },
  { label: '配送公司', value: 'logicCompanys' },
  { label: '配送单号', value: 'logicNumbers' },
  { label: '报缺状态', value: 'lackState' },
  { label: '发货状态', value: 'state' },
  { label: '发货时间', value: 'deliverDate' },
  { label: '物流订单状态', value: 'logisticsState' },
  { label: '处理时间', value: 'updateDate' },
  { label: '型号', value: 'proModel' },
  { label: '订货号', value: 'proOrdernum' }
]
// 自提发货列表-待处理任务-搜素条件
export const pickUp = [
  { label: '发货编号', value: 'deliverNumber' },
  { label: '所在仓库', value: 'storageName' },
  { label: '发货类型', value: 'outstockType' },
  { label: '发货方式', value: 'deliverMode' },
  { label: '发起人', value: 'createUser' },
  { label: '请求发货时间', value: 'createDate' },
  { label: '处理时间', value: 'updateDate' },
  { label: '发货状态', value: 'state' },
  { label: '报缺状态', value: 'lackState' },
  { label: '型号', value: 'proModel' },
  { label: '订货号', value: 'proOrdernum' }
]
// 我的已处理
export const pickUp2 = [
  { label: '发货编号', value: 'deliverNumber' },
  { label: '所在仓库', value: 'storageName' },
  { label: '发货类型', value: 'outstockType' },
  { label: '发货方式', value: 'deliverMode' },
  { label: '发起人', value: 'createUser' },
  { label: '请求发货时间', value: 'createDate' },
  { label: '处理时间', value: 'updateDate' },
  { label: '发货状态', value: 'state' },
  { label: '报缺状态', value: 'lackState' },
  { label: '提货时间', value: 'pickDate' },
  { label: '型号', value: 'proModel' },
  { label: '订货号', value: 'proOrdernum' }
]
// 仓库发货-待处理任务-搜索框
export const warehouse1 = [
  { label: '发货编号', value: 'deliverNumber' },
  { label: '所在仓库', value: 'storageName' },
  { label: '发货类型', value: 'outstockType' },
  { label: '发货方式', value: 'deliverMode' },
  { label: '发起人', value: 'createUser' },
  { label: '请求发货时间', value: 'createDate' },
  { label: '认领人', value: 'staffCnName' },
  { label: '认领时间', value: 'stprocessDateate' },
  { label: '型号', value: 'proModel' },
  { label: '订货号', value: 'proOrdernum' }
]
// 我的待处理任务
export const warehouse2 = [
  { label: '发货编号', value: 'deliverNumber' },
  { label: '所在仓库', value: 'storageName' },
  { label: '发货类型', value: 'outstockType' },
  { label: '发货方式', value: 'deliverMode' },
  { label: '发起人', value: 'createUser' },
  { label: '请求发货时间', value: 'createDate' },
  { label: '认领时间', value: 'updateDate' },
  { label: '发货状态', value: 'state' },
  { label: '报缺状态', value: 'lackState' },
  { label: '型号', value: 'proModel' },
  { label: '订货号', value: 'proOrdernum' }
]
// 我的已处理任务
export const warehouse3 = [
  { label: '发货编号', value: 'deliverNumber' },
  { label: '所在仓库', value: 'storageName' },
  { label: '发货类型', value: 'outstockType' },
  { label: '发货方式', value: 'deliverMode' },
  { label: '发起人', value: 'createUser' },
  { label: '请求发货时间', value: 'createDate' },
  { label: '处理时间', value: 'updateDate' },
  { label: '发货状态', value: 'state' },
  { label: '报缺状态', value: 'lackState' },
  { label: '发货时间', value: 'deliverDate' },
  { label: '型号', value: 'proModel' },
  { label: '订货号', value: 'proOrdernum' }
]
// 询价单筛选条件
export const stockSelector = [
  { label: '备货编号', value: 'stockupCode' },
  { label: '所在仓库', value: 'storageName' },
  { label: '备货方式', value: 'distributionType' },
  { label: '备货仓库', value: 'ocsStorageName' },
  { label: '备货发起人', value: 'createUser' },
  { label: '请求备货时间', value: 'createDate' },
  { label: '认领人', value: 'staffCnName' }
]
// 调拨方式
export const allocationMethod = [
  { label: '物流配送', value: 'Logistics' },
  { label: '快递配送', value: 'express' },
  { label: '仓库配送', value: 'warehouse' }
]
// 下单模式
export const orderPattern = [
  { label: '散单模式', value: '散单模式' },
  { label: '大客户模式', value: '大客户模式' },
  { label: '同步筛单模式', value: ' 同步筛单模式 ' }
]
// 送货方式
export const shipping = [
  { label: '自提', value: '自提' },
  { label: '送货进仓', value: '送货进仓' },
  { label: '送货（不含上楼）', value: '送货（不含上楼）' },
  { label: '送货上楼', value: '送货上楼' },
  { label: '大件上楼', value: '大件上楼' }
]
// 产品类型----------

// 运输方式
export const transportation = [
  {
    label: '快递运输方式',
    value: '快递运输方式',
    arr: [
      'RCP：大件快递360', ' NZBRH：重包入户', 'ZBTH：重包特惠', 'WXJTH：微小件特惠', ' JJDJ：经济大件', 'PACKAGE： 标准快递', 'DEAP：特准快件', 'EPEP ：电商尊享', 'CITYPIECE：'
    ]

  },
  {
    label: '零担运输方式',
    value: '零担运输方式',
    arr: [
      ' JZKY：精准空运（仅散客模式支持该运输方式）', 'JZQY_LONG：精准汽运', ' JZKH：精准卡航', 'AGENT_VEHICLE：汽运偏线', ' DTD：精准大票-经济件', ' YTY：精准大票-标准件', 'PCP：精准包裹'
    ]
  },
  {
    label: '整车运输方式',
    value: '整车运输方式',
    arr: [
      ' JZZC：精准整车 ', 'ZCPS：整车配送 ', 'JZZHC：精准专车', 'JZPC：精准拼车'

    ]
  }
]
// 支付方式
export const payment = [
  { label: '发货人付款（现付）', value: '发货人付款（现付）' },
  { label: '收货人付款（到付)', value: '收货人付款（到付)' },
  { label: '发货人付款（月结）', value: '发货人付款（月结）' }
]
// 签单回单
export const signReceipt = [
  { label: '无需返单', value: '无需返单' },
  { label: '签收单原件返回', value: '签收单原件返回' },
  { label: '客户签收单传真返回 ', value: '客户签收单传真返回' },
  { label: '运单签收联原件返回  ', value: '运单签收联原件返回 ' },
  { label: '运单到达联传真返回 ', value: '运单到达联传真返回' }
]
// 出入库类型
export const inoutSelect = [
  { type: '采购入库', value: '采购入库' },
  { type: '调拨入库', value: '调拨入库' },
  { type: '退货入库', value: '退货入库' },
  { type: '维修入库', value: '维修入库' },
  { type: '销售出库', value: '销售出库' },
  { type: '调拨出库', value: '调拨出库' },
  { type: '退货出库', value: '退货出库' },
  { type: '维修出库', value: '维修出库' },
  { type: '仓内调拨', value: '仓内调拨' }
]
// 配送方式
export const deliverySelect = [
  { deliverType: '供应商配送', value: '供应商配送' },
  { deliverType: '物流配送', value: '物流配送' },
  { deliverType: '快递配送', value: '快递配送' },
  { deliverType: '客户自提', value: '客户自提' },
  { deliverType: '仓库配送', value: '仓库配送' }
]

// 库存备货详情页 快递公司
export const stockProcessedType = [
  // { label: '德邦快递', value: 1 },
  { label: '自定义', value: 2 }
  // { label: '中通快递', value: 3 }
]

// 物流/快递发货详情页 快递公司
export const expressType = [
  // { label: '德邦快递', value: '1' },
  { label: '自定义', value: '2' }
  // { label: '中通快递', value: '3' }
]
// 库存设置->选择
export const codeSelect = [
  { label: '仓库编码', value: 'storageNumber' },
  { label: '仓库名称', value: 'storageName' }
]
// 库存备货清单list数据
export const stockList = [{
  stockNumber: 'BH-191101-1001',
  stockMethods: '仓储备货',
  deliveryTime: '2020-04-13 20:00',
  stockWareHouse: '上海仓',
  telephoneNumber: '021-626000000',
  WareHouseAddress: '上海市嘉定区金园八路358号1号楼',
  sponsor: '李钟硕',
  requestStockTime: '2020-01-15 13:09',
  warranty: ''
}]
// 备货方案提交list数据
// export const programList = [{
//   shelf: 'BH',
//   inboundBatch: 'BH-191101-1001',
//   shelfInventory: '10',
//   history: '21',
//   number: '10'
// }]
